// extracted by mini-css-extract-plugin
export var checkbox = "_8y-0";
export var circle = "_8y-3";
export var horizontalContainer = "_8y-7";
export var sm = "_8y-5";
export var switch0 = "_8y-2";
export var switchDisabled = "_8y-8";
export var switchEnabled = "_8y-1";
export var textSwitchContainer = "_8y-9";
export var textSwitchOption = "_8y-a";
export var textSwitchOptionSelected = "_8y-b";
export var verticalContainer = "_8y-6";
export var xs = "_8y-4";